<template>
  <base-modal name="deleted-successfully">
    <template #body>
      <div class="mt-50 text-center">
        <div class="my-50">
          <img :src="deleteEmptyIcon" alt="delete" class="inline" />
        </div>
        <div class="my-50">
          <h6 class="font-semibold text-18 text-title">
            <span class="block">
              {{ deteled }}
              <span class="text-danger">{{ $t('deleted') }}</span>
            </span>
          </h6>
        </div>
      </div>
    </template>
  </base-modal>
</template>

<script>
import deleteEmpty from '@/assets/icons/svg/Delete_Empty.svg';
import BaseModal from './BaseModal.vue';

export default {
  name: 'DeletedModal',
  components: { BaseModal },
  props: {
    deteled: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      deleteEmptyIcon: deleteEmpty,
    };
  },
};
</script>

<style></style>
